// extracted by css-extract-rspack-plugin
export default {"root":"root-DHgvmR","lead":"lead-eXnbyL","pic":"pic-RAJa5j"};